import { Validators } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}

export const CA1VALIDATORS = {
  CREATE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['idDesativateur', new FormInfo(true, [])],
    ['code', new FormInfo(false, [Validators.required, Validators.maxLength(9)])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(50)])],
    ['site', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [])]
  ]),
  EDIT: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(true, [Validators.required, Validators.maxLength(9)])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(50)])],
    ['site', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [])]
  ]),
  VISUALIZE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(true, [])],
    ['site', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])]
  ])
};

export const SEUILVALIDATORS = {
  CREATE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['seuil1', new FormInfo(false, [Validators.required])],
    ['seuil2', new FormInfo(false, [Validators.required])],
    ['seuil3', new FormInfo(false, [Validators.required])],
    ['seuil4', new FormInfo(false, [Validators.required])],
    ['type', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [])],
    ['codeCa1', new FormInfo(false, [])]
  ]),
  EDIT: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['seuil1', new FormInfo(false, [Validators.required])],
    ['seuil2', new FormInfo(false, [Validators.required])],
    ['seuil3', new FormInfo(false, [Validators.required])],
    ['seuil4', new FormInfo(false, [Validators.required])],
    ['type', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [])],
    ['codeCa1', new FormInfo(false, [])]
  ]),
  VISUALIZE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['seuil1', new FormInfo(true, [])],
    ['seuil2', new FormInfo(true, [])],
    ['seuil3', new FormInfo(false, [])],
    ['seuil4', new FormInfo(false, [])],
    ['type', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])],
    ['codeCa1', new FormInfo(true, [])]
  ])
};

export const CA2VALIDATORS = {
  CREATE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(false, [Validators.required, Validators.maxLength(9)])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(30)])],
    ['codeCa1', new FormInfo(false, [Validators.maxLength(9)])],
    ['imputable', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [])]
  ]),
  EDIT: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(true, [Validators.required, Validators.maxLength(9)])],
    ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(30)])],
    ['codeCa1', new FormInfo(false, [Validators.maxLength(15)])],
    ['imputable', new FormInfo(false, [])],
    ['idSociete', new FormInfo(false, [])]
  ]),
  VISUALIZE: new Map<string, FormInfo>([
    ['id', new FormInfo(false, [])],
    ['dCreation', new FormInfo(true, [])],
    ['idCreateur', new FormInfo(true, [])],
    ['dModification', new FormInfo(true, [])],
    ['idModifieur', new FormInfo(true, [])],
    ['dDesactivation', new FormInfo(true, [])],
    ['code', new FormInfo(true, [])],
    ['libelle', new FormInfo(true, [])],
    ['codeCa1', new FormInfo(false, [Validators.maxLength(15)])],
    ['imputable', new FormInfo(true, [])],
    ['idSociete', new FormInfo(true, [])]
  ])
};
